import Login from "components/authForm/login-form/login-form";
import Register from "components/authForm/register-form/register-form";
import { useState, useContext, useEffect } from "react";
import { MainContext } from 'utils/context';
import { useNavigate } from 'react-router-dom';

export default function Authenticate() {
    const { user } = useContext(MainContext);
    const navigate = useNavigate();
    const [registerMode, setRegisterMode] = useState(false);

    // إذا كان المستخدم مسجل دخوله، انتقل إلى الصفحة الرئيسية
    useEffect(() => {
        if (user) {
            navigate('/');
        }
    }, [user, navigate]);

    return (registerMode ?
        <div className="authenticate">
            <Register />
            <p className="form--p">Already have an account?<span
                onClick={() => setRegisterMode(false)}
                className="form--span">Login</span> </p>

        </div>
        :
        <div className="authenticate">
            <Login />
            <p className="form--p">Don't have an account? <span
                onClick={() => setRegisterMode(true)}
                className="form--span">Register</span>
            </p>

        </div>
    )
}